import React, {useEffect} from 'react';
import ReasonsContent from "./reasons-content.jsx";
import PlacesContent from "./places-content.jsx";
import NeighborhoodsContent from "./neighborhoods-content.jsx";
import HeatMap from "./heat-map.jsx";
import StatusContent from "./status-content.jsx";
import ConditionsContent from "./conditions-content.jsx";
import ReferralDistributionContent from "./referral-distribution-content.jsx";
import CardsContent from "./cards-content.jsx";
import BoListContent from "./bo-list-content.jsx";

const ReportContent = ({data, collapsed, boName}) => {
    return (
        <>
            <BoListContent data={data} boName={boName}/>
            <CardsContent key={`cards-${collapsed}`} data={data} boName={boName}/>
            <StatusContent key={`status-${collapsed}`} data={data} boName={boName}/>

            <div id="graphics-div">

                <ReasonsContent key={`reasons-${collapsed}`} data={data} boName={boName}/>
                <PlacesContent key={`places-${collapsed}`} data={data} boName={boName}/>
                <NeighborhoodsContent key={`neighborhood-${collapsed}`} data={data} boName={boName}/>

                {
                    (data.bosByWeekday?.length && (data.bosByWeekday[0].min != null || data.bosByWeekday[0].max != null)) &&
                    <HeatMap key={`heatMap-${collapsed}`} data={data} boName={boName}/>
                }

                <ConditionsContent key={`conditions-${collapsed}`} data={data} boName={boName}/>

                <ReferralDistributionContent key={`referral-${collapsed}`} data={data} boName={boName}/>

            </div>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;